<div class="row">
    <div class="col-12">
        <h5><small>{{title}}</small></h5>
    </div>

    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaIdentificacion">
            <mat-label>Numero Guia Identificacion</mat-label>
            <input matInput formControlName="numero" type="number">
        </mat-form-field>
    </div>

    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaIdentificacion">
            <mat-label>Descripcion Guia Identificacion</mat-label>
            <input matInput formControlName="descripcion">
        </mat-form-field>
    </div>

    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaIdentificacion">
            <mat-label>Peso Guia Identificacion</mat-label>
            <input matInput formControlName="peso" type="number">
        </mat-form-field>
    </div>
</div>